import ButtonField from '@/components/form-control/ButtonField'
import ButtonFieldLight from '@/components/form-control/ButtonFieldLight'
import { ArrowDownIcon, RefreshIcon } from '@/components/icons'
import { useTranslation } from '@/hooks/useTranslation'
import { DATA_TABLE_SITES_SETUP } from '@/constant/common'
import { Box, Button, Menu, MenuItem, Stack, Typography } from '@mui/material'
import { useState } from 'react'
import FooterSetup from '../../common/FooterSetup'
import MenuHeader from '../../common/MenuHeader'
import RightGoogleMapSmall from '../../common/RightGoogleMapSmall'
import SetUpLayout from '../../common/SetUpLayout'
import SitesTable from './SitesTable'

type Props = {}

const SitesData = (props: Props) => {
  const { t } = useTranslation()
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleAdd = () => {

  }
  const open = Boolean(anchorEl);

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <SetUpLayout
      title='Sites'

      header={
        <MenuHeader />
      }
      rightLayout={<RightGoogleMapSmall />}
      footer={<Stack p="25px 32px"><FooterSetup /></Stack>}
    >
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography sx={{ fontSize: "20px", lineHeight: "2.4" }}>{t('commonLabelsReviewSitesLocationsData')}</Typography>
        <Stack alignItems="center">
          <ButtonField
            startIcon={<></>}
            style={{
              height: '32px',
              minWidth: '89px',
              borderRadius: '5px',
            }}
            name="Done"
            onClick={handleClick}
          />
        </Stack>
      </Stack>
      <Stack direction="row" mb="16px" justifyContent="space-between">
        <Stack direction="row">
          <Stack justifyContent="center">
            <Typography sx={{ color: " #000000", mr: "13px" }}>{t('formsLabelsSelectSite')}</Typography>
          </Stack>
          <Box>
            <Button
              endIcon={<ArrowDownIcon />}
              style={{
                height: '32px',
                minWidth: '89px',
                borderRadius: '5px',
                marginRight: '8px',
                backgroundColor: "rgba(4, 71, 68, 0.2",
                color: "#000000"
              }}
              onClick={handleClick}
            >
              <Typography sx={{ pt: "4px" }}>{t('formsLabelsMainPipe')}</Typography>
            </Button>

            <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
            >
              <MenuItem
                onClick={handleClose}
                disableRipple
                value={'Garden by The Bay'}
                sx={{
                  backgroundColor: '#CDDADA',
                  minWidth: '215px'
                }}>

                <Box>
                  Garden by The Bay
                </Box>
              </MenuItem>
              <MenuItem
                onClick={handleClose}
                disableRipple
                value={'Bay East Garden'}>
                <Box>
                  Bay East Garden
                </Box>
              </MenuItem>
            </Menu>
          </Box>
        </Stack>

        <Box
          sx={{
            marginLeft: '8px'
          }}>
          <ButtonFieldLight
            startIcon={<RefreshIcon />}
            style={{
              height: '32px',
              minWidth: '89px',
              borderRadius: '5px',
            }}
            name="Sync Decoder"
            onClick={handleAdd}
          />
        </Box>
      </Stack>
      <SitesTable rows={DATA_TABLE_SITES_SETUP} />
    </SetUpLayout>
  )
}

export default SitesData